import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { FlatDetail } from 'types/api'
import { BaseParams } from 'types/utils'

interface UpdateGalleryOrderInput {
  order: string[]
}

export function useUpdateGalleryOrder() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError() // Added useOnError

  async function updateOrder({
    id,
    body
  }: BaseParams<UpdateGalleryOrderInput, 'PUT'>) {
    const res = await apiClient.put<FlatDetail>(
      SNA_PREFIX + `flats/${id}/images/reorder`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: updateOrder,
    onSuccess: () => {
      toast.success({ message: t('galleryOrderUpdated') })
      queryClient.invalidateQueries({ queryKey: ['flats'] })
    },
    onError // Updated to use useOnError
  })
}
